import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

export const getRequisa = async (PurchaseRequest) => {
    const result = await PrivateInterceptor(`Compras/PurchaseRequest/obtenerRequisa`, 'POST', {PurchaseRequest} )
    return result;
}

export const obtenerEncabezado = async () => {
    const result = await PrivateInterceptor(`Compras/PurchaseRequest/obtenerEncabezado`, 'GET')
    return result;
}

export const getStatusPurchaseDetails = async () => {
    const respuesta = await PrivateInterceptor('IT/Status/PurchaseDetails', 'GET');
    return respuesta;
}

export const getUltimoID = async () => {
    const respuesta = await PrivateInterceptor('PursacheRequest/ObtenerUltimoID', 'GET');
    return respuesta[0].IdPurchaseRequest;
}

// GET REQUISA FILTRADORS POR FECHA
export const getRequisasFecha = async (data) => {
    return await PrivateInterceptor('Compras/RequisasCompras/RequisasPorFecha', 'POST', data);
}

export const getDatosCompletos = async (Ids) => {
    const result = await PrivateInterceptor(`Compras/PurchaseRequest/obtenerRequisaCompleta`, 'POST', {Ids} )
    return result;
}

export const chageEstadoRequisas = async (IdStatus, Ids) => {
    const result = await PrivateInterceptor(`Compras/PurchaseRequestDetails/chageEstadoRequisas`, 'POST', {IdStatus, Ids});
    return result;
}